module.exports = __webpack_public_path__ + "9c7f73973fc71a85607bd59f9bddf5e0.png";